import { getAuthorizedApi } from "api/apiInstance";
import { baseInternalUrl } from "api/constants";
// import CommonCategoryPage from "components/category";
import { getSession } from "next-auth/react";
import { useRouter } from "next/router";
import dynamic from "next/dynamic";
import { getCtxPayload } from "utils/loggerHelper";
import { logger } from "logging/log-util";
import { v4 as uuidv4 } from "uuid";
import { stateData } from "constants/state";
import { APIS, SERIES_ID } from "constants/cricket";
import Health from "components/category/Health";

const CommonCategoryPage = dynamic(
  () => import("../../../components/category"),
  { ssr: true }
);

export default function SubCategory(props) {
  
  const { query } = useRouter();
  return props?.categoryName == 'health' ? 
  <Health
  {...props}
  categoryName={query.categoryName}
  subCategoryName={query.subCategoryName}
  fromRoot={props.subCategoryName.includes("assembly-chunav")}
/>
  : (
    <CommonCategoryPage
      {...props}
      categoryName={query.categoryName}
      subCategoryName={query.subCategoryName}
      fromRoot={props.subCategoryName.includes("assembly-chunav")}
    />
  );
}

export async function getServerSideProps(ctx) {
  const { categoryName, subCategoryName } = ctx.params;
  const {type} = ctx.query

  const propData = stateData[subCategoryName];
  const breadCrump = propData?.breadCrump;
  console.log(propData, " ", breadCrump);

  if (subCategoryName === "latestnews") {
    return {
      redirect: {
        // destination: dataProps.postData?.permalink,
        destination: "/all/news/latest-news",
        permanent: true,
      },
    };
  }
  const session = await getSession(ctx);
  const lallantop = JSON.parse(ctx.req?.cookies?.lallantop || "{}");

  const ctxId = uuidv4();
  const loggerWithCtx = logger.child({
    ctxId,
    userId: lallantop?.userId,
    page: "Sub Category",
  });
  const ctxPayload = getCtxPayload(ctx, {
    label: "Sub Category CSR : Page Request",
  });
  loggerWithCtx.info(ctxPayload);

  const httpClient = await getAuthorizedApi(
    lallantop.encryptedToken,
    loggerWithCtx
  );
  let newsData = [];
  const liveData = await httpClient.get(
    `${process.env.NEXT_PUBLIC_APP_SSR_URL}/v1/live/listWithStreamUrl?limit=10&skip=1`
  );
  const articlePageBanners = await httpClient.get(
    `${process.env.NEXT_PUBLIC_APP_SSR_URL}/v1/banner/all?source=WEB&category=category-${categoryName}-${subCategoryName}`
  );
  try {
    let liveShowData = liveData?.data?.result;


    let result = null
    if(type == 'text' || type == 'video'){
      result = await httpClient.get(
        `${baseInternalUrl}/web/postListBySubCategory/${categoryName}/${subCategoryName}?limit=25&skip=1&type=${type == 'text' ? 'text,liveblog' : 'video'}`
      );
    }
    else{
      result = await httpClient.get(
        `${baseInternalUrl}/web/postListBySubCategory/${categoryName}/${subCategoryName}?limit=25&skip=1&type=text,video,liveblog`
      );
    }


    const {data} = result
    
    var seoData = [...data?.result?.entities];
    console.log("seoData 1", seoData?.length);
    let electionTopicData = [];
    try {
      if (
        categoryName === "sports"
      ) {
        const topicData = await httpClient.get(
          `${process.env.NEXT_PUBLIC_APP_SSR_URL}/v1/topicItem/getContentsBySlugAndType?limit=10&skip=1&slug=champions-trophy&type=text,video`
        );
        if (topicData && topicData?.data && topicData?.data?.result?.entities) {
          electionTopicData = topicData?.data?.result?.entities;
        }
      }
    } catch (err) {
      console.log("Error on topic ", err);
    }

    let categoryId = data?.result?.entities[0]?.categoryId;
    let catTags = await httpClient.get(
      `${baseInternalUrl}/category/sub-categories?_id=${categoryId}`
    );
    catTags = catTags?.data?.result;

    let metaDetails =
      catTags?.find((category) => category.slug === subCategoryName)
        ?.metaDetails || {};

    const faqData =
      catTags?.find((category) => category?.slug === subCategoryName)?.faqs ||
      {};

    console.log("categoryIdwaa", categoryId);

    newsData = [...data.result?.entities];
    var temp = newsData;
    temp.splice(18);
    newsData = temp;
    console.log("seoData 2", seoData?.length);

    let keyValueArray = [];
    for (let i = 1; i < seoData.length + 1; i++) {
      let position = {};
      let typeKey = "@type";
      let typeValue = "ListItem";
      position[typeKey] = typeValue;
      // position.push({ [typeKey]: typeValue });
      typeKey = "position";
      typeValue = i;
      position[typeKey] = typeValue;
      typeKey = "name";
      typeValue = seoData[i - 1]?.title;
      // position.push({ [typeKey]: typeValue });
      position[typeKey] = typeValue;

      typeKey = "description";
      typeValue = seoData[i - 1]?.shortText;
      position[typeKey] = typeValue;
      typeKey = "url";
      typeValue = seoData[i - 1]?.permalink;
      position[typeKey] = typeValue;
      keyValueArray.push(position);
    }
    seoData = keyValueArray;
    if (newsData?.length === 0) {
      return {
        redirect: {
          permanent: true,
          destination: `/all/${categoryName}`,
          permanent: true,
        },
        props: {},
      };
    }

    let pointsData = null
    let scoreData = {
      live : null,
      upcoming : null
    }
    const results = await Promise.all([
      httpClient.get(
        `https://sports-feeds.intoday.in/live-score/api_v1/lallantop_web/series_standings/${SERIES_ID}_hn_json/`
      ).then(res => {
        return res
      }).catch(err => {
        console.log(err , ' error in the sports.feed points table api ');
        
      }),
      httpClient.get(
        APIS['matches']['live']
      ).then((response) => {
        return response.data
    }).catch(err => {
      console.log(err , ' error in the sports.feed points live api ');
      
    }),
      httpClient.get(
        APIS['matches']['upcoming']
      ).then((response) => {
        return response.data
    }).catch(err => {
      console.log(err , ' error in the sports.feed points upcoming api ');
      
    }),
  
    ])

    if(results[0]?.data){
      pointsData = results[0].data
    }

     //checking if any of the matches are live 
     if(results[1] ){
      scoreData = {
        ...scoreData ,
        live : results[1]
      }
      
    }
    else{
      scoreData = {
        ...scoreData ,
        live : null
      }
      
    }
    //checking if any of the matches are upcoming 
    if(results[2] ){
      scoreData = {
        ...scoreData ,
        upcoming : results[2]
      }
      
    }
    else{
      scoreData = {
        ...scoreData ,
        upcoming : null
      }
      
    }
    try {
      ctx?.res?.setHeader("Cache-Control", `max-age=360, stale-if-error=86400`);
    } catch (error) {
      console.error("cache error", error);
    }
    return {
      props: {
        // session,
        newsData,
        seoData,
        electionTopicData,
        liveShowData,
        metaDetails,
        pointsData,
        scoreData,
        faqData,
        propData: propData ? propData : null,
        breadCrump: breadCrump ? breadCrump : [],
        articlePageBanners: articlePageBanners?.data?.result,
        subCategoryName,
      }, // will be passed to the page component as props
    };
  } catch (err) {


    console.log(err)
    return {
      redirect: {
        // destination: dataProps.postData?.permalink,
        destination: `/all/${categoryName}`,
        // permanent: true,
      },
    };
  }
}
